/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _menu = __webpack_require__(1);

	var _menu2 = _interopRequireDefault(_menu);

	var _sliders = __webpack_require__(4);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _stickyHeader = __webpack_require__(3);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	var _jsFormValidate = __webpack_require__(5);

	var _jsFormValidate2 = _interopRequireDefault(_jsFormValidate);

	var _select = __webpack_require__(6);

	var _select2 = _interopRequireDefault(_select);

	var _search = __webpack_require__(7);

	var _search2 = _interopRequireDefault(_search);

	var _calendar = __webpack_require__(8);

	var _calendar2 = _interopRequireDefault(_calendar);

	var _equalHeight = __webpack_require__(9);

	var _equalHeight2 = _interopRequireDefault(_equalHeight);

	var _windowResize = __webpack_require__(10);

	var _windowResize2 = _interopRequireDefault(_windowResize);

	var _pagnation = __webpack_require__(11);

	var _pagnation2 = _interopRequireDefault(_pagnation);

	var _messages = __webpack_require__(12);

	var _messages2 = _interopRequireDefault(_messages);

	var _resetFilter = __webpack_require__(13);

	var _resetFilter2 = _interopRequireDefault(_resetFilter);

	var _ajaxComplete = __webpack_require__(14);

	var _ajaxComplete2 = _interopRequireDefault(_ajaxComplete);

	var _stockpotArchive = __webpack_require__(17);

	var _stockpotArchive2 = _interopRequireDefault(_stockpotArchive);

	var _accordions = __webpack_require__(18);

	var _accordions2 = _interopRequireDefault(_accordions);

	var _letterFilter = __webpack_require__(19);

	var _letterFilter2 = _interopRequireDefault(_letterFilter);

	var _emptyParagraphs = __webpack_require__(20);

	var _emptyParagraphs2 = _interopRequireDefault(_emptyParagraphs);

	var _readMoreContent = __webpack_require__(15);

	var _readMoreContent2 = _interopRequireDefault(_readMoreContent);

	var _siteMapMenu = __webpack_require__(21);

	var _siteMapMenu2 = _interopRequireDefault(_siteMapMenu);

	var _detectIE = __webpack_require__(22);

	var _detectIE2 = _interopRequireDefault(_detectIE);

	var _hideEmptyAds = __webpack_require__(16);

	var _hideEmptyAds2 = _interopRequireDefault(_hideEmptyAds);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	jQuery(function () {
		// Site Menu
		_menu2.default.init();

		// Slick Slider
		_sliders2.default.init();

		// Empty Parahraphs
		_emptyParagraphs2.default.init();

		// Sticky header
		_stickyHeader2.default.init();

		//Messages
		_messages2.default.init();

		//Messages
		_pagnation2.default.init();

		// Frontend form validation
		_jsFormValidate2.default.init();

		// Select 2
		_select2.default.init();

		// Search
		_search2.default.init();

		// Calendar
		_calendar2.default.init();

		// Equal Height
		_equalHeight2.default.init();

		// Reset Filter
		_letterFilter2.default.init();

		// Detect IE
		_detectIE2.default.init();

		// Read More Content
		_readMoreContent2.default.init();

		// Reset Filter
		_resetFilter2.default.init();

		// Stockpot Archive
		_stockpotArchive2.default.init();

		// Accordions
		_accordions2.default.init();

		// Site Map Menu
		_siteMapMenu2.default.init();

		// Hide Ads
		_hideEmptyAds2.default.init();

		// Ajax Complete
		_ajaxComplete2.default.init();

		// WindowResize
		// WindowResize.init();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	var _stickyHeader = __webpack_require__(3);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Menu = {
		/*-------------------------------------------------------------------------------
	 # Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domMenuBtn: $('.js-menu-btn'),
		$domMenuNav: $('.js-main-nav'),
		$domMenuHasSub: $('.js-main-nav .menu-item--collapsed'),
		$domMenuItem: $('.menu > li').find('.parent-expanded'),
		$domMenuItemParent: $('.menu > li.menu-item--expanded'),
		$domMenuButtonToggle: $('.menu > li').children('span'),
		classOpen: 'open',
		classOpenMenu: 'menu-open',
		classSubMenu: '.menu-item--expanded > .menu',
		classSubIcon: '.sub-icon',
		classMenu: '.menu',
		classList: 'li',

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			$('.js-drupal-fullcalendar').attr('id', 'calendar');

			Menu.$domMenuNav.find('.home-button').parent().addClass('home-button-parent');

			if (_global2.default.varsWindowWidth < 992) {

				Menu.$domMenuItem.each(function (i, el) {
					$(el).parent().append('<span class="sub-icon font-angle" data-open-sub></span>');
				});
			}

			if (_global2.default.varsWindowWidth > 991) {

				Menu.$domMenuItem.append('<span class="font-angle"></span>');

				// Menu.$domMenuNav.find('.menu-item--active-trail').children('ul').addClass('box-shadow menu-visible');

				Menu.$domMenuItemParent.mouseover(function (e) {
					var self = $(e.currentTarget);
					Menu.$domMenuNav.find('.menu-item--active-trail').children('ul').addClass('menu-visible box-shadow');
					if (!self.hasClass('menu-item--active-trail')) {
						Menu.$domMenuNav.find('.menu-item--active-trail').children('ul').removeClass('menu-visible box-shadow');
						self.children('ul').addClass('box-shadow menu-visible');
						self.children('a').addClass('is-active');
					}
				});

				Menu.$domMenuItemParent.mouseleave(function (e) {
					Menu.$domMenuNav.find('.menu-item--active-trail').children('ul').addClass('menu-visible box-shadow');
					var self = $(e.currentTarget);
					if (!self.hasClass('menu-item--active-trail')) {
						self.children('a').removeClass('is-active');
						self.children('ul').removeClass('menu-visible box-shadow');
					}
				});
			}

			// functions
			var closeNav = function closeNav() {
				Menu.$domMenuBtn.removeClass(Menu.classOpen);
				Menu.$domMenuNav.removeClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass(Menu.classOpen);
				_global2.default.$domBody.removeClass(Menu.classOpenMenu);
			};

			// bind events
			Menu.$domMenuBtn.on('click', function (e) {
				e.preventDefault();
				Menu.$domMenuBtn.toggleClass(Menu.classOpen);
				Menu.$domMenuNav.toggleClass(Menu.classOpen);
				// .find(Menu.classSubMenu)
				// .slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass('open');
				_global2.default.$domBody.toggleClass(Menu.classOpenMenu);
			});

			$('span.sub-icon').each(function (e) {
				if ($(this).parent('li').hasClass('menu-item--active-trail')) {
					$(this).addClass('menu-visible');
					$(this).siblings('ul').slideDown();
				}
			});

			Menu.$domMenuNav.on('click', '[data-open-sub]', function (e) {
				var self = $(e.currentTarget);

				if (self.siblings('.menu').is(':hidden')) {
					self.siblings('ul.menu').slideDown();
					self.addClass('menu-visible');
					self.parent().addClass('toggled');
					self.parent().siblings('li.menu-item--expanded').removeClass('toggled');
					self.parent().siblings('li.menu-item--expanded').children('span').removeClass('menu-visible');
					self.parent().siblings('li.menu-item--expanded').children('.menu').slideUp();
				} else {
					self.siblings('ul.menu').slideUp();
					self.removeClass('menu-visible');
				}
			});

			_global2.default.functions.clickOutsideContainer(Menu.$domMenuNav, Menu.$domMenuNav.find('ul'), Menu.$domMenuBtn, closeNav);

			_global2.default.functions.escKey(closeNav);
		}
	};

	exports.default = Menu;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}
		}
	};

	exports.default = Global;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Sticky = {
		/*-------------------------------------------------------------------------------
	 # Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$navigation: $('#site-navigation'),
		$content: $('.js-site-content'),
		$preheader: $('.c-header-fixed-wrapper'),
		$preheaderMobile: $('.c-header--pre-header'),
		$preheaderMediaMobile: $('.c-header--media'),
		classSticky: 'sticky-header',
		classStickyContent: 'sticky-content',

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			var prevScrollpos = window.pageYOffset;
			var page = Sticky.$content;
			var body = page.scrollTop();

			if (window.pageYOffset === body) {
				if (_global2.default.varsWindowWidth > 991) {
					$('.js-main-nav').find('.menu-item--active-trail').children('ul').addClass('menu-visible box-shadow');
					Sticky.$navigation.addClass('static').removeClass('fixed').removeClass('invisible').removeClass('fixed-bigger-top');
					Sticky.$preheader.removeClass('fixed');
				} else {
					Sticky.$preheaderMobile.addClass('static').removeClass('fixed').removeClass('invisible').removeClass('fixed-bigger-top');
					Sticky.$preheaderMediaMobile.removeClass('fixed');
				}
			}
			window.onscroll = function () {
				var y = $(this).scrollTop();
				var currentScrollPos = window.pageYOffset;

				if (y <= 151) {

					if (window.pageYOffset === body) {
						if (_global2.default.varsWindowWidth > 991) {
							$('.js-main-nav').find('.menu-item--active-trail').find('.font-angle').addClass('rotate');
							$('.js-main-nav').find('.menu-item--active-trail').children('ul').addClass('menu-visible box-shadow');
							Sticky.$navigation.addClass('static');
						}
					} else {
						if (_global2.default.varsWindowWidth > 991) {
							$('.js-main-nav').find('.menu-item--active-trail').children('ul').removeClass('menu-visible box-shadow');
							$('.js-main-nav').find('.menu-item--active-trail').find('.font-angle').removeClass('rotate');
							Sticky.$preheader.addClass('fixed').removeClass('fixed-bigger-top').removeClass('invisible-preheader');
							Sticky.$navigation.addClass('fixed').removeClass('invisible').removeClass('fixed-bigger-top');
						} else {
							Sticky.$preheaderMediaMobile.addClass('fixed').removeClass('fixed-bigger-top').removeClass('invisible-preheader');
							Sticky.$preheaderMobile.addClass('fixed').removeClass('invisible').removeClass('fixed-bigger-top');
						}
					}
				} else {
					if (_global2.default.varsWindowWidth > 991) {
						$('.js-main-nav').find('.menu-item--active-trail').find('.font-angle').removeClass('rotate');
						$('.js-main-nav').find('.menu-item--active-trail').children('ul').removeClass('menu-visible box-shadow');
						Sticky.$navigation.addClass('fixed').removeClass('invisible-nav').removeClass('static');
					} else {
						Sticky.$preheaderMobile.addClass('fixed').removeClass('invisible-nav').removeClass('static');
					}
					if (prevScrollpos > currentScrollPos) {

						if (prevScrollpos > currentScrollPos + 20) {

							if (_global2.default.varsWindowWidth > 991) {
								Sticky.$preheader.addClass('fixed').removeClass('invisible-preheader');
								Sticky.$navigation.removeClass('fixed-bigger-top');
							} else {
								Sticky.$preheaderMediaMobile.addClass('fixed').removeClass('invisible-preheader');
								Sticky.$preheaderMobile.removeClass('fixed-bigger-top');
							}
						}
					} else {
						if (y > 150) {

							if (_global2.default.varsWindowWidth > 991) {
								Sticky.$navigation.addClass('fixed-bigger-top');
								Sticky.$preheader.addClass('invisible-preheader').removeClass('fixed');
							} else {
								Sticky.$preheaderMobile.addClass('fixed-bigger-top');
								Sticky.$preheaderMediaMobile.addClass('invisible-preheader').removeClass('fixed');
							}
						} else if (y <= 151) {

							if (_global2.default.varsWindowWidth > 991) {
								Sticky.$preheader.removeClass('fixed').removeClass('invisible-preheader');
								Sticky.$navigation.addClass('static').removeClass('fixed').removeClass('invisible');
							} else {
								Sticky.$preheaderMediaMobile.removeClass('fixed').removeClass('invisible-preheader');
								Sticky.$preheaderMobile.addClass('static').removeClass('fixed').removeClass('invisible');
							}
						}
					}
					prevScrollpos = currentScrollPos;
				}
			};
		}
	};

	exports.default = Sticky;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 # Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSlider: $('.js-slider'),
		$domSliderBanner: $('.js-slider-banner'),
		$domSliderBannerThumbnail: $('.slider-nav'),
		$domSliderBannerPrev: $('.slick-button.prev'),
		$domSliderBannerNext: $('.slick-button.next'),
		$domSliderPreheaderMedia: $('.c-header--media'),
		$domYoutubeChannelList: $('#youtubechannel-list').find('ul'),
		$domLogoSlider: $('.logo-contact-wrapper--logo').find('.logo-slider').find('.field-field_logo'),
		$domAmwardsSlider: $('.view-sponsors').find('.views-rows'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			var _Sliders$$domAmwardsS;

			// Slider
			Sliders.$domSlider.slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: false,
				dots: true,
				responsive: [{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}]
			});

			// Banner Slider
			Sliders.$domSliderBanner.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				asNavFor: Sliders.$domSliderBannerThumbnail,
				fade: false
			});

			Sliders.$domSliderBannerThumbnail.slick({
				slidesToShow: 4,
				slidesToScroll: 4,
				infinite: false,
				asNavFor: Sliders.$domSliderBanner,
				dots: false,
				centerMode: false,
				focusOnSelect: true,
				variableWidth: true,
				arrows: false
			});

			Sliders.$domSliderBannerNext.on('click', function () {
				Sliders.$domSliderBanner.slick("slickNext");
			});

			Sliders.$domSliderBannerPrev.on('click', function () {
				Sliders.$domSliderBanner.slick("slickPrev");
			});

			// Preheader Media Slider
			// if (Global.varsWindowWidth < 992) {
			//
			// 	const preHeaderMediaLogo = Sliders.$domSliderPreheaderMedia.find('.c-header--media-logo');
			// 	preHeaderMediaLogo.detach();
			//
			// 	Sliders.$domSliderPreheaderMedia.slick({
			// 		infinite: true,
			// 		slidesToShow: 1,
			// 		slidesToScroll: 1,
			// 		dots: false,
			// 		centerMode: false,
			// 		nav: false,
			// 		prevArrow: false,
			// 	 	nextArrow: false,
			// 	});
			// }

			// Youtube Suggested Videos Slider
			if (_global2.default.varsWindowWidth < 1244) {

				Sliders.$domYoutubeChannelList.slick({
					infinite: true,
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: true,
					centerMode: false,
					nav: false,
					prevArrow: false,
					nextArrow: false,
					responsive: [{
						breakpoint: 991,
						settings: {
							slidesToShow: 1
						}
					}]
				});
			}

			// Partner single logo slider
			Sliders.$domLogoSlider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: false,
				dots: true
			});

			// Awards slider
			Sliders.$domAmwardsSlider.slick((_Sliders$$domAmwardsS = {
				infinite: false,
				slidesToShow: 3,
				slidesToScroll: 3
			}, _defineProperty(_Sliders$$domAmwardsS, 'infinite', true), _defineProperty(_Sliders$$domAmwardsS, 'speed', 1000), _defineProperty(_Sliders$$domAmwardsS, 'prevArrow', "<a href='#' class='nav nav-next font-arrow'></a>"), _defineProperty(_Sliders$$domAmwardsS, 'nextArrow', "<a href='#' class='nav nav-prev font-arrow'></a>"), _defineProperty(_Sliders$$domAmwardsS, 'autoplay', false), _defineProperty(_Sliders$$domAmwardsS, 'dots', true), _defineProperty(_Sliders$$domAmwardsS, 'responsive', [{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}]), _Sliders$$domAmwardsS));
		}
	};

	exports.default = Sliders;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var FormValidate = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		// Use this class for every form you whant to validate
		classForm: '.js-validation',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			if ($(FormValidate.classForm).length > 0) {
				$.validate({
					form: FormValidate.classForm
				});
			}
		}
	};

	exports.default = FormValidate;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2 = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSelect: $('select'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// drupal fix for multilingual
			var selectPlaceholder = Drupal.t("Select an option");

			Select2.$domSelect.select2({
				placeholder: '' + selectPlaceholder,
				width: '100%'
			});
		}
	};

	exports.default = Select2;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Search = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domSearch: $('.about-us-search-wrapper').find('#views-exposed-form-search-page-1').find('#edit-search-api-fulltext'),
	  $domSearchFormAction: $('.about-us-search-wrapper').find('#views-exposed-form-search-page-1').find('.form-actions'),
	  $domSearchInput: $('.about-us-search-wrapper').find('#views-exposed-form-search-page-1').find('.js-form-submit'),
	  $domForm: $('.about-us-search-wrapper').find('#views-exposed-form-search-page-1'),
	  $domAboutMenu: $('header').find('#block-aboutmenu'),
	  $domSearchPageSubmit: $('.page-search').find('#block-exposedformsearch-page').find('.form-submit'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/

	  init: function init() {
	    // drupal fix for multilingual

	    var body = _global2.default.$domBody;

	    body.on('click', function (e) {
	      if ($(e.target).closest(Search.$domForm).length == 0) {
	        Search.$domForm.removeClass('search');

	        if (_global2.default.varsWindowWidth > 991) {
	          Search.$domAboutMenu.slideDown();
	        }
	      }
	    });

	    Search.$domSearchFormAction.on('click', function (e) {

	      Search.$domForm.toggleClass('search');

	      if (_global2.default.varsWindowWidth > 991) {
	        Search.$domAboutMenu.slideToggle();
	      }

	      Search.$domSearch.bind("change paste keyup", function () {

	        if (Search.$domSearch.val().length == 0) {
	          Search.$domSearchInput.removeClass('filled');
	        } else {
	          Search.$domSearchInput.addClass('filled');
	        }
	      });
	    });

	    //Search page
	    var searchPageForm = $('.page-search').find('#block-exposedformsearch-page');
	    var searchPageInput = $('.page-search').find('#block-exposedformsearch-page').find('#edit-search-api-fulltext');
	    var searchTextBox = $('.page-search').find('#block-drupal-starter-page-title').find('h1').find('span');

	    Search.$domSearchPageSubmit.on('click', function (e) {
	      searchTextBox.text($(searchPageInput).val());
	    });
	  }
	};

	exports.default = Search;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var $ = jQuery.noConflict();

	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Calendar = {

	  $calendar: $('.js-drupal-fullcalendar'),
	  $zero: $('.fc-basicDay-view').find('.fc-content-skeleton').find('td'),
	  $archiveMonths: $('.archive-main-wrapper'),
	  $archiveLists: $('.archive-main-wrapper').find('ul'),
	  $archiveEventListMobile: $('.archive-main-wrapper').children('div'),

	  init: function init() {

	    var zeroState = $('.fc-basicDay-view').find('.fc-content-skeleton').find('tbody').find('tr');
	    var calendarTitle = $('.js-drupal-fullcalendar').find('.fc-left').find('h2');

	    if (Calendar.$calendar.length) {
	      var _Calendar$$calendar$f;

	      Calendar.$calendar.fullCalendar('destroy');

	      Calendar.$calendar.fullCalendar((_Calendar$$calendar$f = {

	        header: {
	          left: 'title',
	          center: 'month',
	          right: 'prev,next'
	        },
	        firstDay: 1,
	        defaultDate: drupalSettings.defaultDate,
	        locale: drupalSettings.defaultLang,
	        navLinks: drupalSettings.navLinks == 0 ? false : true,
	        editable: true,
	        eventLimit: false,
	        events: drupalSettings.fullCalendarView,
	        eventOverlap: false,
	        timeFormat: 'H:mm',
	        contentHeight: 'auto'
	      }, _defineProperty(_Calendar$$calendar$f, 'contentHeight', function contentHeight() {
	        // if (Global.varsWindowWidth < 991) {
	        //   return 500;
	        // }
	      }), _defineProperty(_Calendar$$calendar$f, 'eventAfterAllRender', function eventAfterAllRender() {
	        $('.js-drupal-fullcalendar').addClass('loaded');

	        if ($('.fc-basicDay-view').find('.fc-content-skeleton').height() < 20) {
	          $('td:empty:first').each(function (i, item) {
	            $(this).addClass('empty-cell').append('<p class="zero-state">There are no events for this day</p>');
	          });
	        }

	        $('.fc-month-button').html('Month view');

	        if (window.innerWidth < 991) {
	          Calendar.$calendar.css('height', '500px');
	        }

	        Calendar.$calendar.find('.fc-left').find('h2').each(function () {
	          var elText,
	              openSpan = '<span class="month">',
	              closeSpan = '</span>';
	          elText = $(this).text().split(" ");
	          elText.unshift(openSpan);
	          elText.splice(2, 0, closeSpan);
	          elText = elText.join(" ");
	          $(this).html(elText);
	        });
	      }), _defineProperty(_Calendar$$calendar$f, 'eventRender', function eventRender(event, element) {
	        var dataToFind = moment(event.start).format('YYYY-MM-DD');
	        $("td[data-date='" + dataToFind + "']").addClass('activeDay');
	      }), _Calendar$$calendar$f));
	    }

	    Calendar.$archiveMonths.find('.month').each(function () {
	      var monthContent = $(this).children('a').attr('class');
	      var listContent = Calendar.$archiveLists.find('a').text();

	      if (listContent.indexOf(monthContent) != -1) {
	        $(this).addClass('has-events');
	      }
	    });

	    if (_global2.default.varsWindowWidth < 576 || _global2.default.varsWindowWidth > 991 && _global2.default.varsWindowWidth < 1150) {
	      Calendar.$archiveEventListMobile.children('.year').on('click', function (e) {
	        var self = $(e.currentTarget);
	        if (self.siblings('.month').is(':hidden')) {
	          self.siblings('.month').slideDown();
	          self.parent().addClass('menu-visible');
	          self.parent().siblings().removeClass('menu-visible');
	          self.parent().siblings().children('.month').slideUp();
	        } else {
	          self.siblings('.month').slideUp();
	          self.parent().removeClass('menu-visible');
	        }
	      });
	    }
	  }
	};

	exports.default = Calendar;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var EqualHeight = {

	  $resource: $('#youtubechannel-player'),
	  $resourceHeader: $('#youtubechannel-list'),
	  //$resourceFooter: $('[class*="node--type"].node--view-mode-teaser').find('.links'),
	  $resourceBody: $('[class*="node--type"].node--view-mode-teaser').find('.field--name-body'),

	  init: function init() {

	    // const equalHeights = (elm) => {
	    //   setTimeout(() => {
	    //     let x = 0;
	    //
	    //     elm.height('auto');
	    //
	    //     elm.each((index, el) => {
	    //       if ($(el).height() > x) {
	    //         x = $(el).height();
	    //       }
	    //     });
	    //
	    //     elm.height(x + 1);
	    //   }, 100);
	    // };
	    // //
	    // //Resource item Equal heights
	    // equalHeights(EqualHeight.$resourceHeader);
	    // // equalHeights(EqualHeight.$resourceBody);
	    // // //equalHeights(EqualHeight.$resourceFooter);
	    // equalHeights(EqualHeight.$resource);
	  }
	};

	exports.default = EqualHeight;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _equalHeight = __webpack_require__(9);

	var _equalHeight2 = _interopRequireDefault(_equalHeight);

	var _menu = __webpack_require__(1);

	var _menu2 = _interopRequireDefault(_menu);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();
	// import jQuery from "jquery";


	'use strict'; // jshint ignore:line

	var WindowResize = {

	  init: function init() {

	    $(window).resize(function () {
	      _menu2.default.init();
	    });

	    // const equalHeightsEventTop = () => {
	    //   const featuredEventsBlock = $('#block-views-block-events-listing-block-1').find('.view-events-listing');
	    //   const calendar = $('#calendar');
	    //   const startHeight = calendar.height() + 100;
	    //
	    //   featuredEventsBlock.css('height', startHeight);
	    // }
	    //
	    // if($(window).width() > 768) {
	    //   EqualHeights.init();
	    // }
	    //
	    //
	    // if($(window).width() >= 1024) {
	    //   equalHeightsEventTop();
	    // }
	    //
	    // $(window).resize(() => {
	    //   // EqualHeights.init();
	    //   // equalHeightsEventTop();
	    //
	    //   if($(window).width() > 768) {
	    //     EqualHeights.init();
	    //   }
	    //
	    //   if($(window).width() >= 1024) {
	    //     equalHeightsEventTop();
	    //   }
	    // })
	  }
	};

	exports.default = WindowResize;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Pagnation = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/

	    init: function init() {
	        var pagerItem = $('.pager').find('.pager__item > a');

	        pagerItem.on('click', function (e) {
	            var vievTarget = $(e.currentTarget).closest('.views-element-container');
	            var offsetView = vievTarget.offset().top - 250;
	            console.log();

	            $(document).ajaxComplete(function () {

	                $([document.documentElement, document.body]).animate({
	                    scrollTop: offsetView
	                }, 100);

	                $([document.documentElement, document.body]).animate({
	                    scrollTop: offsetView + 1
	                }, 100);
	            });
	        });
	    }
	};

	exports.default = Pagnation;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Messages = {
	    $statusMessages: $('body').find('div[aria-label*="Status message"]'),
	    $errorMessages: $('body').find('div[aria-label*="Error message"]'),
	    $warningMessages: $('body').find('div[aria-label="Warning message"]'),

	    init: function init() {
	        Messages.$statusMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide');
	        });

	        Messages.$errorMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide');
	        });

	        Messages.$warningMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide');
	        });
	    }
	};

	exports.default = Messages;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var ResetFilter = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domResetFilter: $('.event-categories').find('.reset-button'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    ResetFilter.$domResetFilter.bind('click', function (e) {
	      e.preventDefault();
	      window.location.href = window.location.origin + '/events';
	    });
	  }
	};

	exports.default = ResetFilter;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _readMoreContent = __webpack_require__(15);

	var _readMoreContent2 = _interopRequireDefault(_readMoreContent);

	var _hideEmptyAds = __webpack_require__(16);

	var _hideEmptyAds2 = _interopRequireDefault(_hideEmptyAds);

	var _resetFilter = __webpack_require__(13);

	var _resetFilter2 = _interopRequireDefault(_resetFilter);

	var _stickyHeader = __webpack_require__(3);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line

	var AjaxComplete = {

		init: function init() {

			$(document).ajaxComplete(function () {

				_hideEmptyAds2.default.init();

				_readMoreContent2.default.init();

				_resetFilter2.default.init();

				_stickyHeader2.default.init();
			});
		}
	};

	exports.default = AjaxComplete;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var ReadMoreContent = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/

	  init: function init() {

	    var hiddenContent = $('.field-body');
	    var showHiddenContent = $('.field-body').text();
	    var readMore = $('a.content-trigger');

	    hiddenContent.each(function (e) {
	      var count = $(this).find("p").length;
	      var countTables = $(this).find("ul").length;
	      var countUls = $(this).find("table").length;
	      if (count == 1 && countTables == 0 && countUls == 0) {
	        $(this).siblings('.content-trigger').hide();
	      }
	    });

	    readMore.on('click', function (e) {
	      e.preventDefault();
	      var self = $(e.currentTarget);
	      if (self.text() == "Read more") {
	        self.parent().addClass('more-content');
	        self.text("Read less");
	      } else {
	        self.parent().removeClass('more-content');
	        self.text("Read more");
	      }
	    });
	  }
	};

	exports.default = ReadMoreContent;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var HideAds = {

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/

	  init: function init() {

	    _global2.default.$domBody.addClass('visible');

	    $(window).bind("load", function () {
	      // ADD-ON js solution
	      var googleAdd = $('#block-sidebaradds').find('div[id*="google_ads_iframe_"]');
	      setTimeout(function () {
	        googleAdd.each(function (index, el) {

	          if ($(el).html().length > 0) {
	            $(el).parent().addClass('not-empty');
	          } else {
	            $(el).parent().addClass('empty');
	            $(el).closest('.field-body').addClass('empty');
	            $('.layout-sidebar-second--twitter-feed').addClass('without-ads');
	          }
	        });
	      }, 500);
	    });

	    var googleAdd = $('#block-sidebaradds').find('div[id*="google_ads_iframe_"]');
	    setTimeout(function () {
	      googleAdd.each(function (index, el) {

	        if ($(el).html().length > 0) {
	          $(el).parent().addClass('not-empty');
	        } else {
	          $(el).parent().addClass('empty');
	          $(el).closest('.field-body').addClass('empty');
	          $('.layout-sidebar-second--twitter-feed').addClass('without-ads');
	        }
	      });
	    }, 500);
	  }
	};

	exports.default = HideAds;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var StockpotArchive = {
	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  $domStockArchiveMenu: $('nav#block-stockpotmagazinearchive').find('li.menu-item--expanded'),

	  init: function init() {

	    StockpotArchive.$domStockArchiveMenu.on('click', function (e) {
	      var self = $(e.currentTarget);
	      if (self.children('.menu').is(':hidden')) {
	        self.children('ul.menu').slideDown();
	        self.addClass('menu-visible');
	        self.siblings().removeClass('menu-visible');
	        self.siblings().children('.menu').slideUp();
	      } else {
	        self.children('ul.menu').slideUp();
	        self.removeClass('menu-visible');
	      }
	    });
	  }
	};

	exports.default = StockpotArchive;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Accordions = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domAccordionMenu: $('.tab-aboutus-links').children('a'),
	  $domAccordionBody: $('.tabs-aboutus-content').children('.aboutus-tab'),
	  $domAccordionNav: $('.tabs-aboutus-content').find('a.read-more'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    // drupal fix for multilingual

	    Accordions.$domAccordionMenu.on('click', function (e) {
	      var self = $(e.currentTarget);
	      if (!self.hasClass('active-item')) {
	        Accordions.$domAccordionMenu.removeClass('active-item');
	        Accordions.$domAccordionBody.slideUp();
	        Accordions.$domAccordionBody.css('display', 'none');
	        $('#' + $(self).attr('class')).slideDown();
	        self.addClass('active-item');
	      }
	    });

	    Accordions.$domAccordionNav.on('click', function (e) {
	      var self = $(e.currentTarget);
	      var texthref = self.attr('href');
	      Accordions.$domAccordionMenu.removeClass('active-item');
	      Accordions.$domAccordionBody.slideUp();
	      Accordions.$domAccordionBody.css('display', 'none');
	      $('' + $(self).attr('href')).slideDown();
	      self.addClass('active-item');

	      var linkHref = $(e.currentTarget).attr('href');
	      var linkHrefClear = linkHref.substring(1, linkHref.length);

	      Accordions.$domAccordionMenu.each(function (index, el) {
	        var linkClass = $(el).attr('class');

	        if (linkClass == linkHrefClear) {
	          $(el).addClass('active-item');
	        }
	      });

	      $([document.documentElement, document.body]).animate({
	        scrollTop: $(".main-content").offset().top
	      }, 100);

	      $([document.documentElement, document.body]).animate({
	        scrollTop: $(".main-content").offset().top + 1
	      }, 100);
	    });
	  }
	};

	exports.default = Accordions;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var LetterFilter = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domLetterFilterActive: $('.view-display-id-attachment_1').find('.views-rows').find('span'),
	  $domLetterFilterDoubleContent: $('.views-element-container').siblings('.views-rows'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    var articleTitle = $('article').find('.field-title').text().charAt(0).toUpperCase(); // redundant code?

	    var href = location.href;

	    LetterFilter.$domLetterFilterActive.each(function () {

	      if ($(this).find('a').text() == href.match(/([^\/]*)\/*$/)[1]) {
	        $(this).addClass('active-item');
	        LetterFilter.$domLetterFilterDoubleContent.hide();
	      } else {
	        LetterFilter.$domLetterFilterActive.last().addClass('active-item');
	      }
	    });
	  }
	};

	exports.default = LetterFilter;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var EmptyParagraphs = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domParagraphs: $('p'),
	  $domLocationParagraphs: $('.paragraph--type--location'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/

	  init: function init() {
	    // drupal fix for multilingual

	    EmptyParagraphs.$domParagraphs.filter(function () {
	      var html = $(this).html();
	      if (html == '' || html == '&nbsp;') return true;
	    }).remove();

	    EmptyParagraphs.$domLocationParagraphs.each(function (e) {
	      if (!$.trim($(this).html())) {
	        $(this).html('No location provided');
	      }
	    });
	  }
	};

	exports.default = EmptyParagraphs;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var SiteMapMenu = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domSiteMenuParent: $('.sitemap-menu').find('li.expanded'),
	  $domSiteMenuTrigger: $('.content > .sitemap-menu'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/

	  init: function init() {
	    // drupal fix for multilingual
	    SiteMapMenu.$domSiteMenuParent.append('<span class="font-angle"></span>');

	    var siteMenuTrigger = $('.sitemap-menu').find('li.expanded').find('span.font-angle');

	    siteMenuTrigger.on('click', function (e) {
	      var self = $(e.currentTarget);

	      if (self.siblings('.sitemap-menu').hasClass('menu-expanded')) {
	        self.siblings('.sitemap-menu').removeClass('menu-expanded');
	        self.removeClass('triggered');
	      } else {
	        SiteMapMenu.$domSiteMenuTrigger.find('.sitemap-menu').removeClass('menu-expanded');
	        self.siblings('.sitemap-menu').addClass('menu-expanded');
	        siteMenuTrigger.removeClass('triggered');
	        self.addClass('triggered');
	      }
	    });
	  }
	};

	exports.default = SiteMapMenu;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var DetectIE = {

	  init: function init() {

	    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

	    if (isIE11) {
	      $('body').addClass('ie11');
	    }
	  }
	};

	exports.default = DetectIE;

/***/ })
/******/ ]);